import type { CustomHeaderButtonRenderData } from '@1js/suiteux-shell';
import { safeRequestAnimationFrame } from 'owa-performance';
import getO365ShellShim from './getO365ShellShim';

export default function setShellButtonVisibility(
    renderData: CustomHeaderButtonRenderData,
    isVisible: boolean
): void {
    safeRequestAnimationFrame(() =>
        getO365ShellShim().Extensibility.AddOrUpdateCustomHeaderButton({
            ...renderData,
            hideButton: !isVisible,
        })
    );
}
